import { createContext } from 'react';
import { type ThemeState } from '@atlaskit/tokens';

export type ThemeValue = 'dark' | 'light';

export const ThemeContext = createContext<{
  theme: Partial<ThemeState>;
  setTheme?: (theme: Partial<ThemeState>) => void;
}>({ theme: { colorMode: 'light' }, setTheme: undefined });
